module.exports = __webpack_public_path__ + "static/media/morakot-bg2.d377339c.png";